import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import SkillCard from "../SkillCard";
import LanguageCard from "../LanguageCard";
import SobreMimCard from "../SobreMimCard";
import FormationCard from "../FormationCard";
import ExperienceCard from "../ExperienceCard";
import CourseCard from "../CourseCard";
import NivelPerfil from "../Sidebar/NivelPerfil";
import SobreAlunoCard from "../SobreAlunoCard";
import MinhasVagas from "../MinhasVagas/MinhasVagas";
import MeusCursos from "../MeusCursos/MeusCursos";
import { CiLogout } from "react-icons/ci";
import { IoMdDownload } from "react-icons/io";
import { FaRegEdit } from "react-icons/fa";
import "./styles.css";
import { GrCopy } from "react-icons/gr";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { pdf } from "@react-pdf/renderer";
import Curriculum from "../../curriculum";
import { useParams } from "react-router-dom";
import CalendarAluno from "../calendarAluno";

function ProfileAluno() {
  const history = useHistory();

  const handleEditClick = () => {
    history.push("/dashboard/profilecurriculum");
  };
  const profile = useSelector((state) => {
    if (state?.user?.profile?.dataValues) {
      return state.user.profile.dataValues;
    } else {
      return state.user.profile || {};
    }
  });

  async function downloadCurriculum(profile) {
    const blob = await pdf(<Curriculum candidate={profile} />).toBlob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${profile.nome_social || profile.name}.pdf`;
    a.click();
  }

  return (
    <Box component="main" sx={{ flexGrow: 1, p: 0 }} style={{ width: "100%" }}>
      <div className="WelcomeTextBox">
        <CiLogout color="#e86225" size={25} />
        <h2>
          Bem-vindo a Plataforma <span>Oxetech</span>
        </h2>
      </div>
      <div className="NivelSobreAluno">
        <NivelPerfil />
        <SobreAlunoCard />
      </div>
      <div className="profileAlunoArea">
        <div className="cursosBoxArea">
          <MeusCursos />
          <MinhasVagas />
        </div>
        <div className="curriculumBoxArea">
          <div className="curriculumBox">
            <button className="ButtonEditCurriculum" onClick={handleEditClick}>
              <GrCopy size={50} />
              Editar Currículo <FaRegEdit size={25} />
            </button>
            <button
              className="ButtonDownloadCurriculum"
              onClick={() => downloadCurriculum(profile)}
            >
              <GrCopy size={50} />
              Baixar Currículo <IoMdDownload size={25} />
            </button>
          </div>
          <CalendarAluno />
        </div>
      </div>
    </Box>
  );
}

export default ProfileAluno;

//cores plataforma  #e86225 #255aa7
